import {
  IActivatedTaxSystem,
  IActivateTaxSystem,
  ITaxSystem,
  IPossDevices,
  ILinkPosDevice,
  IEGPTaxCheckConnection,
  ISYRRestaurantTax,
  IUAETaxPeriod,
} from "adminPanel/settings/settingTaxes/ITaxSystem";
import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";

const baseUrl = getApiBaseUrl();

export interface ISyriaStoreLinking {
  id: string;
  name: string;
  stationNumber: string | null;
  isStationNumberValid: boolean;
  isLinked: boolean;
  type: string;
  username: string | null;
  password: string | null;
}

export interface ILinkSyriaStore {
  storeId: string;
  stationNumber: string;
  username: string;
  password: string;
}

export interface ISYRTaxCheckConnection {
  statusCode: number;
  resultStatus: string;
  message?: string | null;
  supportId?: string | null;
}

function ActivateTaxSystem(taxSystemData: IActivateTaxSystem) {
  return axios.post<boolean>(`${baseUrl}taxes/activate-system`, taxSystemData);
}

function GetActiveTaxSystem() {
  return axios.get<IActivatedTaxSystem>(`${baseUrl}taxes/active-system`);
}

function GetPOSsDevices() {
  return axios.get<IPossDevices[]>(`${baseUrl}EGPTaxes/get-poss-devices`);
}

function LinkPosDevice(linkData: ILinkPosDevice) {
  return axios.post<boolean>(`${baseUrl}EGPTaxes/link-pos-device`, {
    posDevice: linkData,
  });
}

function IsPosLinkedWithDevice(posId: string) {
  return axios.get<boolean>(
    `${baseUrl}EGPTaxes/pos-linked-device?posId=${posId}`,
  );
}

function EGPTaxCheckConnection(
  provider: string,
  username: string,
  password: string,
) {
  return axios.post<IEGPTaxCheckConnection>(
    `${baseUrl}EGPTaxes/check-connection`,
    {
      provider: provider,
      username: username,
      password: password,
    },
  );
}

function GetSyriaStoreLinking() {
  return axios.get<ISyriaStoreLinking[]>(
    `${baseUrl}SYRTaxes/get-store-linking`,
  );
}

function LinkSyriaStore(linkData: ILinkSyriaStore) {
  return axios.post<boolean>(`${baseUrl}SYRTaxes/link-store`, linkData);
}

function IsPosStoreLinkedToStation(posId: string) {
  return axios.get<boolean>(
    `${baseUrl}SYRTaxes/pos-store-linked?posId=${posId}`,
  );
}

function SYRTaxCheckConnection(
  stationNumber: string,
  username: string,
  password: string,
) {
  return axios.post<ISYRTaxCheckConnection>(
    `${baseUrl}SYRTaxes/check-connection`,
    {
      stationNumber,
      username,
      password,
    },
  );
}

function GetSYRRestTaxesQuery() {
  return axios.get<ISYRRestaurantTax[]>(
    `${baseUrl}SYRTaxes/get-rest-taxes`,
  );
}

function GetUAETaxPeriods() {
  return axios.get<IUAETaxPeriod[]>(`${baseUrl}UAETaxes/get-periods`);
}

function CreateUAETaxPeriod(data: {
  code: string;
  latinName: string;
  arabicName: string;
  startDate?: string | null;
  endDate: string;
}) {
  return axios.post<IUAETaxPeriod>(`${baseUrl}UAETaxes/create-period`, data);
}



const taxesAPI = {
  ActivateTaxSystem,
  GetActiveTaxSystem,
  GetPOSsDevices,
  LinkPosDevice,
  IsPosLinkedWithDevice,
  EGPTaxCheckConnection,
  GetSyriaStoreLinking,
  LinkSyriaStore,
  IsPosStoreLinkedToStation,
  SYRTaxCheckConnection,
  GetSYRRestTaxesQuery,
  GetUAETaxPeriods,
  CreateUAETaxPeriod,
};

export default taxesAPI;
